import "./style/headerTemplate.scss";
import { Header } from "antd/lib/layout/layout";
import { useAppDispatch, useAppSelector } from "../../../util/hooks";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Modal, Tooltip } from "antd";
import { AccountState, setModalAlterarSenhaUsuario } from "../../../redux/slices/account/accountSlice";
import { ConfiguracoesState } from "../../../redux/slices/configuracoes/configuracoesSlice";
import { PersistedState } from "../../../redux/slices/persisted/persistedSlice";
import AlterarSenhaUsuarioModal from "../../../views/usuario/modals/alterarSenha";

const HeaderTemplate = () => {
  //Estados Globais
  const persistedState: PersistedState = useAppSelector((state) => state.persisted);
  const accountState: AccountState = useAppSelector((state) => state.account);
  const configuracoesState: ConfiguracoesState = useAppSelector((state) => state.configuracoes);

  //hooks
  const dispatch = useAppDispatch();

  const isProduction = import.meta.env.VITE_APP_ENV === "production" ? true : false;

  const goAlterarSenha = () => {
    dispatch(setModalAlterarSenhaUsuario(true));
  };

  const closeModalAlterarSenha = () => {
    dispatch(setModalAlterarSenhaUsuario(false));
  };

  return (
    <>
      {!isProduction && (
        <div
          style={{
            // position: "fixed",
            fontWeight: "bold",
            top: 0,
            left: 0,
            width: "100%",
            height: "40px",
            backgroundColor: "yellow",
            color: "black",
            textAlign: "center",
            lineHeight: "40px",
            // zIndex: 1000, // Para ficar acima de outros elementos
          }}
        >
          AMBIENTE DE HOMOLOGAÇÃO - NÃO É O AMBIENTE DE PRODUÇÃO
        </div>
      )}
      <Header className="header">
        <div className="divHeader">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div>{configuracoesState.title}</div>
            <div style={{ fontSize: "11px", marginTop: "-40px", opacity: "80%" }}>{configuracoesState.subTitle}</div>
          </div>
          <div className="divInfos">
            <div>
              <UserOutlined /> {persistedState.user.nome}
            </div>
            <div style={{ backgroundColor: "#000000", opacity: "80%", width: 1, height: 13, marginLeft: 10, marginRight: 10, marginTop: 26 }}></div>
            <div onClick={goAlterarSenha} style={{ cursor: "pointer" }}>
              <Tooltip title="Alterar senha">
                <LockOutlined />
              </Tooltip>
            </div>
          </div>
        </div>
      </Header>
      <Modal title={"ALTERAR SENHA USUÁRIO"} centered width={350} open={accountState.modalAlterarSenha} onCancel={closeModalAlterarSenha} footer={null} destroyOnHidden>
        <AlterarSenhaUsuarioModal origem="header" />
      </Modal>
    </>
  );
};

export default HeaderTemplate;
